import api from './api';

export const discoverService = {
  /**
   * Get monthly leaderboard
   */
  async getLeaderboard(options = {}) {
    const params = new URLSearchParams();
    if (options.month) params.append('month', options.month);
    if (options.scope) params.append('scope', options.scope);
    if (options.limit) params.append('limit', String(options.limit));
    
    const queryString = params.toString();
    const url = `/discover/leaderboard${queryString ? `?${queryString}` : ''}`;
    
    const response = await api.get(url);
    return response.data?.data;
  },

  /**
   * Get social feed
   */
  async getFeed(options = {}) {
    const params = new URLSearchParams();
    if (options.scope) params.append('scope', options.scope);
    if (options.cursor) params.append('cursor', options.cursor);
    if (options.limit) params.append('limit', String(options.limit));
    
    const queryString = params.toString();
    const url = `/discover/feed${queryString ? `?${queryString}` : ''}`;
    
    const response = await api.get(url);
    return response.data?.data;
  },

  /**
   * Follow a user
   */
  async followUser(userId) {
    const response = await api.post(`/discover/follow/${userId}`);
    return response.data?.data;
  },

  /**
   * Unfollow a user
   */
  async unfollowUser(userId) {
    const response = await api.delete(`/discover/follow/${userId}`);
    return response.data?.data;
  },

  /**
   * Get user's discover profile
   */
  async getProfile(userId) {
    const response = await api.get(`/discover/profile/${userId}`);
    return response.data?.data;
  },

  /**
   * Enter the monthly contest
   */
  async enterContest(rulesVersion) {
    const response = await api.post('/discover/contest/enter', { rulesVersion });
    return response.data?.data;
  },

  /**
   * Get contest status
   */
  async getContestStatus() {
    const response = await api.get('/discover/contest/status');
    return response.data?.data;
  },

  /**
   * Claim a contest prize (initiates Stripe Connect onboarding)
   */
  async claimPrize() {
    const response = await api.post('/discover/contest/claim');
    return response.data;
  },

  /**
   * Get claim status for winners
   */
  async getClaimStatus() {
    const response = await api.get('/discover/contest/claim/status');
    return response.data?.data;
  },
};

export default discoverService;

